<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButton
            variant="secondary"
            @click="$router.go(-1)"
            icon="icon-outline_arrow-left"
            :text="$t('global.back')"
          />
        </div>
      </div>
    </div>

    <div class="clearfix mb-4">
      <h4 class="card-title float-start">{{ $t('master.form.fleet.fleetInformation') }}</h4>
    </div>
    <b-card>
      <b-row class="mc-list-info__top">
        <b-col>
          <span>{{ $t('global.object.licensePlate') }}</span>
          <strong>{{ vehicle?.licensePlate }}</strong>
        </b-col>

        <b-col>
          <span>{{ $t('global.field.vehicleType') }}</span>
          <strong>{{ vehicle?.vehicleType?.type }}</strong>
        </b-col>

        <b-col>
          <span>{{ $t('global.object.fleetCategory') }}</span>
          <strong>{{ vehicle?.vehicleType?.category }}</strong>
        </b-col>

        <b-col>
          <span>{{ $t('setting.list.fleetSetting.fleetModel') }}</span>
          <strong>{{
            `${vehicle?.vehicleType?.manufacturer} - ${vehicle?.vehicleType?.model}`
          }}</strong>
        </b-col>
      </b-row>
    </b-card>

    <div class="row">
      <div class="col-12">
        <!-- Table -->
        <div class="table-responsive my-3">
          <McGrapqlTable
            :apiClient="query"
            :fields="fields"
            :hasCheckbox="false"
            :searchable="true"
            :withCard="true"
          >
            <template #cell(time)="data">
              {{ data.value ? momentDMY_HI(data.value) + ' WIB' : '' }}
            </template>
          </McGrapqlTable>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import McGrapqlTable from '@/components/McGrapqlTable'
import McButton from '@/components/McButton'
import { LOG_SERVICE_SCHEDULES } from '@/services/api/maintenance/log'
import { Helper } from '@/mixin/helper'
import { GET_VEHICLE_ID } from '@/services/api/master/fleet'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Servis',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McGrapqlTable,
    McButton,
  },

  mixins: [Helper],

  apollo: {
    vehicle: {
      query: GET_VEHICLE_ID,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            id: Number(this.$route.params.vehicleId),
          },
        }
      },
      result({ data }) {
        this.vehicle = data.vehicle.vehicle
      },
    },
  },

  data() {
    return {
      show_model: [],
      data: [],
      vehicle: {},
    }
  },

  computed: {
    title() {
      return `${this.$t('global.historyUpdate')}`
    },

    items() {
      return [
        {
          text: this.$t('maintenance.title'),
          to: { name: 'Service' },
        },
        {
          text: this.$t('maintenance.frontPage.title.serviceSchedule'),
          to: { name: 'List Service Schedule' },
        },
        {
          text: this.$t('maintenance.detailSchedule.title'),
          to: {
            name: 'Detail Service Schedule',
            params: { vehicleId: this.$route.params.vehicleId },
          },
        },
        {
          text: this.$t('global.historyUpdate'),
          active: true,
        },
      ]
    },

    fields() {
      return [
        {
          key: 'time',
          label: this.$t('global.time'),
          sortable: true,
          thClass: 'mc-table--250',
          isRedirectable: false,
        },
        {
          key: 'entity',
          label: this.$t('maintenance.field.compName'),
          sortable: true,
        },
        {
          key: 'action',
          label: this.$t('global.changeDescription'),
          sortable: true,
        },
        {
          key: 'detail',
          label: this.$t('global.information'),
          sortable: true,
        },
        {
          key: 'user',
          label: this.$t('global.changed'),
          sortable: true,
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          return this.get(filter)
        },
      }
    },
  },

  methods: {
    async get(filter) {
      const vehicleId = Number(this.$route.params.vehicleId)
      const res = await this.$apollo.query({
        query: LOG_SERVICE_SCHEDULES,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            ...filter,
            vehicleId: vehicleId,
          },
        },
      })

      const result = {
        data: res.data.serviceScheduleAuditLogs.serviceScheduleAuditLogs.data,
        pagination: res.data.serviceScheduleAuditLogs.serviceScheduleAuditLogs.pagination,
      }

      this.data = res.data.serviceScheduleAuditLogs.serviceScheduleAuditLogs.data

      return result
    },
  },
}
</script>
